export class LocaleInfo {
    Locale: string;
    Base: string;
    Name: string;
    Id: number;
    Iso2: string;
    Facebook: string;
    Codes: string[];
    Validation: string;

    constructor(
        locale: string,
        base: string,
        name: string,
        id: number,
        iso2: string,
        facebook: string,
        codes: string[],
        validation: string,
    ) {
        this.Locale = locale;
        this.Base = base;
        this.Name = name;
        this.Id = id;
        this.Iso2 = iso2;
        this.Facebook = facebook;
        this.Codes = codes;
        this.Validation = validation;
    }
}
